@for (filterGroup of filterGroups; track filterGroup) {
  <div
    class="group">
    @if (filterGroup.visible) {
      <div
      class="group-name">{{ filterGroup.name }}</div>
    }
    <app-catalog-filter [stacked]="true"
      [items]="filterGroup.filterItems"
    (emitItemSelect)="selectTag($event)"></app-catalog-filter>
  </div>
}